import { render, staticRenderFns } from "./AcceptInvite.vue?vue&type=template&id=08005aeb"
import script from "./AcceptInvite.vue?vue&type=script&lang=js"
export * from "./AcceptInvite.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('08005aeb')) {
      api.createRecord('08005aeb', component.options)
    } else {
      api.reload('08005aeb', component.options)
    }
    module.hot.accept("./AcceptInvite.vue?vue&type=template&id=08005aeb", function () {
      api.rerender('08005aeb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/AcceptInvite.vue"
export default component.exports